module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/133e4aa38e1bf1623a771873b842dabc.png";